import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { GameProvider, useGame, useModal } from "./context/GameContext.jsx";
import { PlayerCardModal } from "./components/player/ClickablePlayer.jsx";
import { DeadPlayersModal } from "./components/player/DeadPlayersModal.jsx";
import { HomeScreen } from "./screens/HomeScreen.jsx";
import { SetupScreen } from "./screens/SetupScreen.jsx";
import { RoleRevealScreen } from "./screens/RoleRevealScreen.jsx";
import { GameScreen } from "./screens/GameScreen.jsx";
import { DocsScreen } from "./screens/DocsScreen.jsx";

function AppInner() {
  const { state } = useGame();
  const { modalPlayer, setModalPlayer } = useModal();
  const [showDead, setShowDead] = useState(false);

  return (
    <div className="max-w-md mx-auto relative">
      <AnimatePresence mode="wait">
        {state.screen === "home"   && <HomeScreen   key="home" />}
        {state.screen === "setup"  && <SetupScreen  key="setup" />}
        {state.screen === "reveal" && <RoleRevealScreen key="reveal" />}
        {state.screen === "game"   && <GameScreen   key="game" onOpenDead={() => setShowDead(true)} />}
        {state.screen === "docs"   && <DocsScreen   key="docs" />}
      </AnimatePresence>

      {/* Global modals — rendered outside all screen transforms, never clipped */}
      <AnimatePresence>
        {modalPlayer && (
          <PlayerCardModal key="card-modal" player={modalPlayer} onClose={() => setModalPlayer(null)} />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {showDead && state.session && (
          <DeadPlayersModal key="dead-modal" players={state.session.players} onClose={() => setShowDead(false)} />
        )}
      </AnimatePresence>
    </div>
  );
}

export default function App() {
  return (
    <GameProvider>
      <AppInner />
    </GameProvider>
  );
}
